import { translate } from "@/main";

// i18nがundefinedな状態で翻訳ロジックが走らないようにするためクラス・メソッド化
export default class GraphContentConfig {
  public static regionItems() {
    return [
      { text: "us-east-1", value: "us-east-1" },
      { text: "us-east-2", value: "us-east-2" },
      { text: "us-west-1", value: "us-west-1" },
      { text: "us-west-2", value: "us-west-2" },
      { text: "ca-central-1", value: "ca-central-1" },
      { text: "eu-central-1", value: "eu-central-1" },
      { text: "eu-west-1", value: "eu-west-1" },
      { text: "eu-west-2", value: "eu-west-2" },
      { text: "eu-west-3", value: "eu-west-3" },
      { text: "ap-northeast-1", value: "ap-northeast-1" },
      { text: "ap-northeast-2", value: "ap-northeast-2" },
      { text: "ap-southeast-1", value: "ap-southeast-1" },
      { text: "ap-southeast-2", value: "ap-southeast-2" },
      { text: "ap-south-1", value: "ap-south-1" },
      { text: "sa-east-1", value: "sa-east-1" }
    ];
  }
  public static graphDateFormats() {
    return [
      { text: "MM-DD HH:mm:ss", value: "MM-DD HH:mm:ss" },
      { text: "MM-DD HH:mm:ss.sss", value: "MM-DD HH:mm:ss.SSS" }
    ];
  }
  public static timeFormatItems() {
    return {
      yearMonthDate: [
        { text: "-", value: "-" },
        { text: "/", value: "/" }
      ],
      dateHour: [
        { text: "T", value: "T" },
        { text: translate("message.empty"), value: " " }
      ],
      miliSec: [
        { text: "SSS", value: "SSS" },
        { text: translate("message.empty"), value: "" }
      ],
      timezone: [
        { label: translate("message.empty"), value: "" },
        { label: "Z", value: "[Z]" },
        {
          label: "+00:00",
          value: "Z",
          children: [
            { label: "+14:00", value: "+14:00" },
            { label: "+13:45", value: "+13:45" },
            { label: "+13:00", value: "+13:00" },
            { label: "+12:45", value: "+12:45" },
            { label: "+12:00", value: "+12:00" },
            { label: "+11:30", value: "+11:30" },
            { label: "+11:00", value: "+11:00" },
            { label: "+10:30", value: "+10:30" },
            { label: "+10:00", value: "+10:00" },
            { label: "+09:30", value: "+09:30" },
            { label: "+09:00", value: "+09:00" },
            { label: "+08:45", value: "+08:45" },
            { label: "+08:00", value: "+08:00" },
            { label: "+07:00", value: "+07:00" },
            { label: "+06:30", value: "+06:30" },
            { label: "+06:00", value: "+06:00" },
            { label: "+05:45", value: "+05:45" },
            { label: "+05:30", value: "+05:30" },
            { label: "+05:00", value: "+05:00" },
            { label: "+04:30", value: "+04:30" },
            { label: "+04:00", value: "+04:00" },
            { label: "+03:30", value: "+03:30" },
            { label: "+03:00", value: "+03:00" },
            { label: "+02:30", value: "+02:30" },
            { label: "+02:00", value: "+02:00" },
            { label: "+01:00", value: "+01:00" },
            { label: "±00:00", value: "+00:00" },
            { label: "-01:00", value: "-01:00" },
            { label: "-02:00", value: "-02:00" },
            { label: "-02:30", value: "-02:30" },
            { label: "-03:00", value: "-03:00" },
            { label: "-04:00", value: "-04:00" },
            { label: "-05:00", value: "-05:00" },
            { label: "-06:00", value: "-06:00" },
            { label: "-07:00", value: "-07:00" },
            { label: "-08:00", value: "-08:00" },
            { label: "-09:00", value: "-09:00" },
            { label: "-09:30", value: "-09:30" },
            { label: "-10:00", value: "-10:00" },
            { label: "-11:00", value: "-11:00" },
            { label: "-12:00", value: "-12:00" }
          ]
        },
        {
          label: "+0000",
          value: "ZZ",
          children: [
            { label: "+1400", value: "+14:00" },
            { label: "+1345", value: "+13:45" },
            { label: "+1300", value: "+13:00" },
            { label: "+1245", value: "+12:45" },
            { label: "+1200", value: "+12:00" },
            { label: "+1130", value: "+11:30" },
            { label: "+1100", value: "+11:00" },
            { label: "+1030", value: "+10:30" },
            { label: "+1000", value: "+10:00" },
            { label: "+0930", value: "+09:30" },
            { label: "+0900", value: "+09:00" },
            { label: "+0845", value: "+08:45" },
            { label: "+0800", value: "+08:00" },
            { label: "+0700", value: "+07:00" },
            { label: "+0630", value: "+06:30" },
            { label: "+0600", value: "+06:00" },
            { label: "+0545", value: "+05:45" },
            { label: "+0530", value: "+05:30" },
            { label: "+0500", value: "+05:00" },
            { label: "+0430", value: "+04:30" },
            { label: "+0400", value: "+04:00" },
            { label: "+0330", value: "+03:30" },
            { label: "+0300", value: "+03:00" },
            { label: "+0230", value: "+02:30" },
            { label: "+0200", value: "+02:00" },
            { label: "+0100", value: "+01:00" },
            { label: "±0000", value: "+00:00" },
            { label: "-0100", value: "-01:00" },
            { label: "-0200", value: "-02:00" },
            { label: "-0230", value: "-02:30" },
            { label: "-0300", value: "-03:00" },
            { label: "-0400", value: "-04:00" },
            { label: "-0500", value: "-05:00" },
            { label: "-0600", value: "-06:00" },
            { label: "-0700", value: "-07:00" },
            { label: "-0800", value: "-08:00" },
            { label: "-0900", value: "-09:00" },
            { label: "-0930", value: "-09:30" },
            { label: "-1000", value: "-10:00" },
            { label: "-1100", value: "-11:00" },
            { label: "-1200", value: "-12:00" }
          ]
        }
      ]
    };
  }

  public static drawRangeItems() {
    return [
      { text: `30${translate("message.second")}`, value: "30" },
      { text: `1${translate("message.minute")}`, value: "60" },
      { text: `3${translate("message.minute")}`, value: "180" },
      { text: `5${translate("message.minute")}`, value: "300" },
      { text: `10${translate("message.minute")}`, value: "600" },
      { text: `15${translate("message.minute")}`, value: "900" },
      { text: `30${translate("message.minute")}`, value: "1800" },
      { text: `1${translate("message.hour")}`, value: "3600" },
      { text: `6${translate("message.hour")}`, value: "21600" },
      { text: `12${translate("message.hour")}`, value: "43200" },
      { text: `24${translate("message.hour")}`, value: "86400" },
      { text: `72${translate("message.hour")}`, value: "259200" }
    ];
  }
  public static searchSelect() {
    return [
      { text: translate("message.after"), value: "after" },
      { text: translate("message.before"), value: "before" },
      { text: translate("message.between"), value: "between" }
    ];
  }
}
